class ScxStickyBuy extends HTMLElement {
  constructor() {
    super();
    this.inStock = this.getAttribute("data-in-stock") == "true";
  }

  connectedCallback() {
    /* if (!this.inStock) {
      return;
    } */

    this.setElemHeight();
    this.alwaysShow = this.getAttribute("always_show_mb") == "true";

    window
      .matchMedia("(max-width: 990px)")
      .addEventListener("change", this.setElemHeight.bind(this));

    const targetDiv = document.querySelector("#desktop-buy-button");
    const mobileDiv = document.querySelector("#mobile-buy-btns");
    const isMobile = window.matchMedia("(max-width: 990px)").matches;
    const additionalTriggerDiv = document.querySelector(
      ".shopify-section-group-footer-group"
    );

    const visibleElements = new Set();

    const updateStickyVisibility = () => {
      if (isMobile && this.alwaysShow) {
        const footerVisible = visibleElements.has(additionalTriggerDiv);
        if (footerVisible) {
          mobileDiv.setAttribute("data-show", "false");
        } else {
          mobileDiv.setAttribute("data-show", "true");
        }
      } else {
        if (visibleElements.size > 0) {
          mobileDiv.setAttribute("data-show", "false");
        } else {
          mobileDiv.setAttribute("data-show", "true");
        }
      }
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            visibleElements.add(entry.target);
          } else {
            visibleElements.delete(entry.target);
          }
        });
        updateStickyVisibility();
      },
      {
        root: null,
        threshold: 0.1,
      }
    );

    if (isMobile && this.alwaysShow) {
      if (additionalTriggerDiv) observer.observe(additionalTriggerDiv);
    } else {
      if (targetDiv) observer.observe(targetDiv);
      if (additionalTriggerDiv) observer.observe(additionalTriggerDiv);
    }
  }

  /**
   * This function gets the current header height and sets is as a property.
   * Useful for hide/show header on scroll behavior.
   */
  setElemHeight() {
    const elem = document.getElementById("MainContent");
    const targetElem = this.querySelector("#mobile-buy-btns");

    if (!elem || !targetElem) {
      throw Error("Missing target elements.");
    }

    elem.style.setProperty(
      "--sticky-buy-height",
      `${targetElem.offsetHeight}px`
    );
  }
}

customElements.define("scx-sticky-buy", ScxStickyBuy);
